import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL

// const user = JSON.parse(window.localStorage.getItem('user'))
// if(user) {
//     axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
// }
